import React, { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { Loader } from 'src/components'
import { getCalculateData, isCarCalculeType, isPlaneCalculeType, isParcelCalculeType } from 'src/features'
import CarsCalculateResponseList from './CarsCalculateResponseList/CarsCalculateResponseList'
import PlanesCalculateResponseList from './PlanesCalculateResponseList/PlanesCalculateResponseList'
import ParcelCalculateResponseList from './ParcelCalculateResponseList/ParcelCalculateResponseList'

const DownloadCertificatesStep = () => {
  const dispatch = useAppDispatch()

  const { preViewList, calculeUrl, responseCalculate } = useAppSelector((state) => state.admin.massiveCalculation)
  const { loading } = responseCalculate
  const isCarPreview = useAppSelector(isCarCalculeType)
  const isPlanePreview = useAppSelector(isPlaneCalculeType)
  const isParcelPreview = useAppSelector(isParcelCalculeType)

  useEffect(() => {
    const calculeType = { isCar: isCarPreview, isPlane: isPlanePreview, isParcel: isParcelPreview }
    dispatch(getCalculateData(preViewList, calculeUrl, calculeType))
  }, [dispatch, preViewList, calculeUrl, isCarPreview, isPlanePreview, isParcelPreview])


  return (
    <>
      {isCarPreview ? (
        <CarsCalculateResponseList loading={loading} />
      ) : isPlanePreview ? (
        <PlanesCalculateResponseList loading={loading} />
      ) : isParcelPreview && (
        <ParcelCalculateResponseList loading={loading} />
      )}
      {loading && <Loader />}
    </>
  )
}

export default DownloadCertificatesStep
